import React, { useEffect, useState } from 'react';
import { Plus, X } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles/cardStyles.css';
import { UsersAllergiesGet } from 'apiServices/reducer/apiService';
//import { Allergies, ManageAllergies } from 'components';
import Allergies from '../dialogs/dashboard/addAllergies';
import ManageAllergies from '../dialogs/dashboard/ManageAllergies';


const AllergyCard = ({
    showAddButton,
    onAdd,
    onRemove,
    widgetName,
    draggable = false,
    onDragStart,
    hideHeader = false,
    selectedFamilyMember
}) => {
    const dispatch = useDispatch();
    const userData = useSelector((state) => state.apiService.login);
    const isProvider = userData.user_type_name === 'Provider';
    
    // Use selectedFamilyMember's user_id if available, otherwise use current user's ID
    const userId = selectedFamilyMember?.user_id || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);
    
    const token = useSelector((state) => state.apiService?.token);
    const [allergiesList, setAllergiesList] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showManageModal, setShowManageModal] = useState(false);

    const [editForm, setEditForm] = useState({
        AllergyName: '',
        Reactions: ''
    });

    const fetchAllergies = async () => {
        try {
            const response = await dispatch(UsersAllergiesGet({
                UserID: userId,
                token,
                _cache: Date.now()
            })).unwrap();

            console.log('Full allergy list:', response);

            if (response && Array.isArray(response)) {
                const activeAllergies = response.filter(item =>
                    item.is_active !== false
                );
                setAllergiesList(activeAllergies);
                console.log('Filtered active allergies:', activeAllergies);
            }
        } catch (err) {
            console.error('Fetch error:', err);
        }
    };

    useEffect(() => {
        if (userId && token) {
            fetchAllergies();
        }
    }, [userId, token, selectedFamilyMember]);

    const handleAddClick = () => {
        setEditForm({ AllergyName: '', Reactions: '' });
        setShowAddModal(true);
    };

    const handleManageClick = () => {
        setShowManageModal(true);
    };

    const handleAddModalClose = () => {
        setShowAddModal(false);
    };

    const handleManageModalClose = () => {
        setShowManageModal(false);
    };

    const refreshAllergies = async () => {
        const latest = await dispatch(UsersAllergiesGet({ UserID: userId, token })).unwrap();
        setAllergiesList(latest || []);
    };

    const handleAllergyDelete = (deletedId) => {
        setAllergiesList(prev => prev.filter(a => a.allergy_id !== deletedId));
    };


    return (
        <>
            {!hideHeader ? (
                <div
                className="cardwidget cardwidgetHeight d-flex flex-column shadow-lg shadow-sm border-0 mb-3 rounded-3" draggable={draggable}
                    onDragStart={onDragStart}
                >
                    <div className="cardwidget-header cardwidgehtHeaderBG d-flex justify-content-between align-items-center px-3 py-1">
                        <h6 className="mb-0 text-capitalize">{widgetName || 'Allergies'}</h6>

                        {showAddButton ? (
                            <button
                                className="btn btn-sm px-0"
                                onClick={onAdd}
                                title="Add to Dashboard"
                            >
                                <Plus size={15} color='black' />
                            </button>
                        ) : (
                            <button
                                className="btn btn-sm px-0"
                                onClick={onRemove}
                                title="Remove from Dashboard"
                            >
                                <X size={15} color='black' />
                            </button>
                        )}
                    </div>
                    <div className="cardwidget-body px-3 py-2">
                        {allergiesList.length > 0 ? (
                            <ul className="list-unstyled mb-0">
                                {allergiesList.map((item, index) => (
                                    <li key={item.allergy_id || index} className="mb-3">
                                        <span className="mb-1 d-block">
                                            <strong>{item.allergy_name || 'N/A'}</strong> - {item.reactions || 'N/A'}
                                        </span>
                                        {item.additional_comments && (
                                            <span className="mb-2 text-muted d-block">{item.additional_comments}</span>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="text-muted">No allergy data available.</p>
                        )}
                    </div>

                    {!isProvider &&
                        <>

                            <div className="cardwidget-footer bg-white border-top d-flex justify-content-start px-3 py-2">
                                <button
                                    className="btn btn-link modalfooterclickeventtext p-0 me-2 text-capitalize "
                                    onClick={handleAddClick}
                                >
                                    Add
                                </button>
                                <span className="text-muted">|</span>
                                <button
                                    className="btn btn-link modalfooterclickeventtext p-0 ms-2 text-capitalize"
                                    onClick={handleManageClick}
                                >
                                    Manage
                                </button>
                            </div>
                        </>
                    }
                </div >
            ) : (
                <div style={{ padding: '16px 12px' }}>
                    {allergiesList.length > 0 ? (
                        <ul className="list-unstyled mb-0">
                            {allergiesList.map((item, index) => (
                                <li key={item.allergy_id || index} className="mb-3">
                                    <span>
                                        <strong>{item.allergy_name || 'N/A'}</strong> - {item.reactions || 'N/A'}
                                    </span>
                                    {item.additional_comments && (
                                        <div className="text-muted" style={{ fontSize: '13px' }}>
                                            {item.additional_comments}
                                        </div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="text-muted">No allergy data available.</p>
                    )}
                </div>
            )}

            <Allergies
                show={showAddModal}
                onHide={handleAddModalClose}
                rowData={null}
                editForm={{
                    ...editForm,
                    setFieldValue: (field, value) => setEditForm((prev) => ({ ...prev, [field]: value }))
                }}
                refreshAllergies={fetchAllergies}
                allergiesList={allergiesList}
                userId={userId}
            />

            <ManageAllergies
                show={showManageModal}
                onHide={handleManageModalClose}
                allergiesList={allergiesList}
                refreshAllergies={refreshAllergies}
                onAllergyDelete={handleAllergyDelete}
                userId={userId}
            />
        </>
    );
};

export default AllergyCard;